module.exports = __webpack_public_path__ + "img/logocyd2.ff0a6811.png";